

const Container = props => {
    return (
        <div className="dr-container">
            { props.children }
        </div>
    ) 
}

export default Container;
